import React, { useEffect, useState } from 'react'
import ApexChart from "react-apexcharts"
import moment from 'moment';
import 'moment-duration-format';
import styles from './styles.module.css'


const TopCallDrivers = (props: any) => {

    const [seriesData, setSeriesData] = useState<any>([])

    useEffect(() => {
        let topCallDrivers: any = []
        let averageHandleTime: any = []
        let averageSentimentIndex: any = []
        let averageScore: Array<number> = []
        let labels: any = []
        Object.keys(props.data).map((label: string) => {
            topCallDrivers.push(Math.ceil(props.data[label].volume))
            averageScore.push(Math.ceil(props.data[label].qa_score))
            // averageHandleTime.push(moment.duration(props.data[label].aht, "seconds").format("hh:mm:ss", {trim: "large", stopTrim: "mm"}))
            // averageSentimentIndex.push(Math.ceil(props.data[label].asi))
        })
        setSeriesData([
            {
                "name": 'Volume',
                "type": 'column',
                "data": topCallDrivers
            }, 
            {
                "name": ' Average Score',
                "type": 'line',
                "data": averageScore
            }
            // {
            //     "name": ' Average Handle Time',
            //     "type": 'line',
            //     "data": averageHandleTime
            // }, {
            //     "name": 'Average Sentiment Index',
            //     "type": 'line',
            //     "data": averageSentimentIndex
            // }
        ])
    }, [])

    const colorPallet = ['#008FFB', '#4CAF50', '#FEB019']
    let options: any = {
        chart: {
            type: 'line',
            stacked: false,
            toolbar: {
                show: false,
            }
        },
        legend: {
            show: false,
        },
        colors: colorPallet,
        stroke: {
            width: [0, 3, 3],
            curve: 'smooth'
          },
          plotOptions: {
            bar: {
              columnWidth: '50%'
            }
        },
        grid: {
            show: false,
        },
        labels: Object.keys(props.data),
        markers: {
            size: 0
        },
        xaxis: {
            axisTicks: {
                show: false
            },
            type: 'category',
            labels: {
                show: false,
            },
        },
        yaxis: [
            {
                seriesName: 'Volume',
                max: 100,
                tickAmount: 5,
                axisBorder: {
                  show: true,
                },
                labels: {
                    style: {
                        colors: [colorPallet[0]]
                    }
                },
                title: {
                  text: "Top Conversation Drivers in %",
                  style: {
                      color: colorPallet[0]
                  }
                }
            },
            {
                opposite: true,
                seriesName: 'Average Score',
                labels: {
                    style: {
                        colors: [colorPallet[1]]
                    }
                },
                title: {
                  text: "Average Score in %",
                  style: {
                    color: colorPallet[1]
                    }
                }
            },
            // {
            //     opposite: true,
            //     seriesName: 'Average Handle Time',
            //     labels: {
            //         style: {
            //             colors: [colorPallet[1]]
            //         }
            //     },
            //     title: {
            //       text: "Average Handle Time in minutes",
            //       style: {
            //         color: colorPallet[1]
            //         }
            //     }
            // },
            // {
            //     opposite: true,
            //     seriesName: 'Average Sentiment Index',
            //     labels: {
            //         style: {
            //             colors: [colorPallet[2]]
            //         }
            //     },
            //     title: {
            //       text: "Average Sentiment Index",
            //       style: {
            //         color: colorPallet[2]
            //         }
            //     }
            // },
        ],
        tooltip: {
            enable: true,
            shared: true,
            intersect: false,
            marker: {
                show: false,
            },
            y: {
                formatter: function(value: any, { series, seriesIndex, dataPointIndex, w }: any) {
                    if(seriesIndex == 0) {
                        return value + '%'
                    } else if(seriesIndex == 1) {
                        return value + '%'
                    } 
                    return value
                },
                
            },
            // custom: function({series, seriesIndex, dataPointIndex, w}: any) {
            //     return  '<div class="arrow_box d-flex">' +
            //                 '<span> Ticket Type:' + Object.keys(props.data)[dataPointIndex] + '% </span>' +
            //                 '<span> Average Handle Time:' + series[1][dataPointIndex] + 'sec </span>' +
            //                 '<span> Average Sentiment Index:' + series[2][dataPointIndex] + '</span>' +
            //             '</div>'
            // }
            // y: {
            //   formatter: function (y) {
            //     if (typeof y !== "undefined") {
            //       return y.toFixed(0) + " points";
            //     }
            //     return y;
          
            //   }
            // }
        },
        title: {
            text: 'Top Conversation Drivers',
            align: 'left',
            margin: 10,
            offsetX: 0,
            offsetY: 0,
            floating: false,
            style: {
              fontSize:  '14px',
              fontWeight:  'bold',
              fontFamily:  undefined,
              color:  '#263238'
            }
        },
    }  

    return (
            <ApexChart
                options={options}
                series={seriesData}
                type="line"
                height={230}
            />
    )
}

export default TopCallDrivers
